// extracted by mini-css-extract-plugin
export default {"notice":"RebidNotice_notice__kBEMz","icon":"RebidNotice_icon__fZo-E"};